import soundIcon from "../assets/images/icons/sound.svg";
import SalonActivityLayout from "../components/SalonActivityLayout";
import { useTranslation } from "../components/Localization";

export default function SalonRadioTaskPage() {
  const { t } = useTranslation();
  return <SalonActivityLayout taskKey="radio" step={2} progressIcon="top-right" backTo="/szalon/terites" nextTo="/szalon/video">
    <div className="salon-radio" aria-label={t("accessibility.radioAudio")}><img className="salon-speaker" src={soundIcon} alt="" /><div className="salon-radio-body" aria-hidden="true"><span /><span /><div>{Array.from({ length: 96 }, (_, index) => <i key={index} />)}</div></div></div>
  </SalonActivityLayout>;
}
